package com.eladfinish.bible.contest.constants.strings

val traditionsNames: List<String> =
    listOf(
        "A-רוב העדות",
        "א-אשכנזים",
        "ס-ספרדים",
        "ת-תימנים",
        "ט-איטלקים",
        "נ-תוניסאים",
        "ח-חב\"דים",
        "ב-בלדים",
    )

/** Tradition code (a haftara key in parashot.json, e.g. "א") → the tradition's name ("אשכנזים"). */
val traditionNamesByCode: Map<String, String> =
    traditionsNames.associate { it.take(1) to it.substring(2) }

/** The tradition's name as it follows "מסורת": with the definite article ("האשכנזים"), except "רוב העדות". */
fun traditionNameAfterLabel(code: String): String? =
    traditionNamesByCode[code]?.let { if (it.startsWith("רוב")) it else "ה$it" }
